import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { MenuItem } from './menu-item.model';

@Component({
  selector: 'tyl-general-mat-menu',
  templateUrl: 'tyl-general-mat-menu.component.html',
  exportAs: 'menuTrigger',
})

export class TylGeneralMatMenuComponent implements OnInit {
    @ViewChild(MatMenu, { static: true }) menu: MatMenu;

    @Input() topMenuItems: string[];
    @Input() disabledTopMenuItems: string[] = [];
    @Input() disabledTopMenuItemsBoolean: boolean[] = [];

    @Input() bottomMenuItems: string[];
    @Input() disabledBottomMenuItems: string[] = [];
    @Input() disabledBottomMenuItemsBoolean: boolean[] = [];
    @Input() data: any;
    @Input() showSeparator: boolean;
    @Output() menuClick  = new EventEmitter<MenuItem>();

    ngOnInit(): void {

    }

    topMenuItemClicked(index: number) {
        if (!this.isTopMenuItemDisabled(index)) {
			const menuItem = new MenuItem(this.topMenuItems[index], this.data);

			this.menuClick.next(menuItem);
        }
    }

    bottomMenuItemClicked(index: number) {
        if (!this.isBottomMenuItemDisabled(index)) {
			const menuItem = new MenuItem(this.bottomMenuItems[index], this.data);

			this.menuClick.next(menuItem);
        }
    }

    isTopMenuItemDisabled(index: number): boolean {
        return this.disabledTopMenuItems.includes(this.topMenuItems[index]) || (this.disabledTopMenuItemsBoolean.length > 0 && this.disabledTopMenuItemsBoolean[index]);
    }

    isBottomMenuItemDisabled(index: number): boolean {
        return this.disabledBottomMenuItems.includes(this.bottomMenuItems[index]) || (this.disabledBottomMenuItemsBoolean.length > 0 && this.disabledBottomMenuItemsBoolean[index]);
    }
}
